import { useState, useEffect } from 'react';

import { useRouter } from 'libs/router/useRouter';
import { subscribeStaticContentLoading } from 'libs/router/staticContentLoadingSignal';

import { ProgressLine } from 'ui/atoms/ProgressLine/ProgressLine';

const RouteProgress = () => {
  const { events } = useRouter();

  const [isRouteChanging, setIsRouteChanging] = useState(false);
  const [isContentLoading, setIsContentLoading] = useState(false);
  const [percentage, setPercentage] = useState<null | number>(null);

  useEffect(() => {
    const onStart = () => setIsRouteChanging(true);
    const onDone = () => setIsRouteChanging(false);

    events.on('routeChangeStart', onStart);
    events.on('routeChangeComplete', onDone);
    events.on('routeChangeError', onDone);

    return () => {
      events.off('routeChangeStart', onStart);
      events.off('routeChangeComplete', onDone);
      events.off('routeChangeError', onDone);
    };
  }, [events]);

  // Static pages (src/landing-pages) hold this true for as long as
  // their own JS chunk is still loading, so the bar below waits for BOTH the
  // route transition and the chunk before it finishes — one reveal, not two.
  useEffect(() => subscribeStaticContentLoading(setIsContentLoading), []);

  const isLoading = isRouteChanging || isContentLoading;

  useEffect(() => {
    setPercentage((current) => {
      if (isLoading) {
        return current === null || current === 100 ? Math.random() * (40 - 10) + 10 : current;
      }

      return current === null ? null : 100;
    });
  }, [isLoading]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (percentage === 100) {
      timeoutId = setTimeout(() => setPercentage(null), 450);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [percentage]);

  return <ProgressLine className="progress-bar" percentage={percentage} />;
};

// eslint-disable-next-line import/no-default-export
export default RouteProgress;
